import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CategoryComponent } from 'src/app/modules/user/category/category.component';
import { SidebarComponent } from 'src/app/shared/components/sidebar/sidebar.component';

declare const $: any;
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  level1: any;
  level2: any;
  filter: boolean;
  static selectedType = 'impa'; // impa / customized
  //SearchService.selectedType
  baseUrl = environment.cloudUrl;
  searchOption = [];
  // public postsData: Post[];

  categoryIMPAUrl = this.baseUrl + 'catalogue/search';
  elasticPostUrl = this.baseUrl + 'catalogue/custom/search';
  // levelOneGetUrl = this.baseUrl + 'catalogue/search';
  // levelTwoGetUrl = this.baseUrl + 'catalogue/search';
  qpram: string;

  constructor(private http: HttpClient) {}
  // Searchresult get details
  async searchResult(searchkey: string): Promise<any> {
    searchkey = searchkey.trim();
    this.qpram = searchkey;
    let apiUrl =
      SidebarService.selectedType == 'impa'
        ? this.categoryIMPAUrl
        : this.elasticPostUrl;
    // apiUrl +='?pagesize='+this.pagesize+'&pageNo='+pageNo;
    // if (searchkey && searchkey != '') {
    //   apiUrl += `?q=${searchkey}`;
    // }

    let $level1 = $('#level1').val();
    let $level2 = $('#level2').val();
    let level1 = typeof $level1 != undefined && $level1 ? $level1 : '';
    let level2 = typeof $level2 != undefined && $level2 ? $level2 : '';
    if (level1 && !level2) {
      apiUrl +=
        '?q=' +
        encodeURIComponent(searchkey) +
        '&level1=' +
        encodeURIComponent(level1) +
        '&filter=' +
        true;
    } else if (level1 && level2) {
      apiUrl +=
        '?q=' +
        encodeURIComponent(searchkey) +
        '&level1=' +
        encodeURIComponent(level1) +
        '&level2=' +
        encodeURIComponent(level2);
    } else {
      apiUrl += '?q=' + encodeURIComponent(searchkey);
    }
    // if (typeof level2 !== undefined && level2 == '' && level2) {
    //   apiUrl += '?q=' + searchkey + '&level2=' + level2;
    // } else {
    //   apiUrl += `?q=${searchkey}`;
    // }

    console.log(apiUrl);
    //   return $.ajax({url:apiUrl,method:'get',async:true})
    return this.http.get(apiUrl).toPromise();
  }
  getLevelOne(level1): Observable<any> {
    let url = this.categoryIMPAUrl;
    let qParam = this.qpram;
    if (!qParam) {
      url += '?level1=' + encodeURIComponent(level1) + '&filter=' + true;
    } else {
      url +=
        '?level1=' +
        encodeURIComponent(level1) +
        '&q=' +
        encodeURIComponent(qParam);
    }
    console.log(url)
    return this.http.get(url);
  }
  getLevelTwo(level1, level2): Observable<any> {
    let url = this.categoryIMPAUrl;
    let qParam = this.qpram;
    if (qParam) {
      url +=
        '?level1=' +
        encodeURIComponent(level1) +
        '&level2=' +
        encodeURIComponent(level2) +
        '&q=' +
        encodeURIComponent(qParam);
    } else {
      url +=
        '?level1=' +
        encodeURIComponent(level1) +
        '&level2=' +
        encodeURIComponent(level2) +
        '&filter=' +
        true;
    }
    return this.http.get(url);
  }
}
